import styled from '@emotion/styled'

import type { ButtonMedusaAction, ButtonModifier } from '@polycups/react'

import { ButtonLink } from '@/components/Button'
import { Container } from '@/components/Container'

import { decodeURL } from '@/core/utils/dom/decodeURL'

import { MIDDLE_BUTTON_BACKGROUND_COLORS, MIDDLE_BUTTON_BACKGROUND_VARIANTS } from './constants'

const Background = styled('div', {
  shouldForwardProp: (propName) => propName !== 'background',
})<{ background: MiddleButtonBackgroundVariants }>`
  background: linear-gradient(
    to bottom,
    rgb(${(props) => MIDDLE_BUTTON_BACKGROUND_COLORS[props.background].firstHalf}) 0%,
    rgb(${(props) => MIDDLE_BUTTON_BACKGROUND_COLORS[props.background].firstHalf}) 50%,
    rgb(${(props) => MIDDLE_BUTTON_BACKGROUND_COLORS[props.background].secondHalf}) 50%,
    rgb(${(props) => MIDDLE_BUTTON_BACKGROUND_COLORS[props.background].secondHalf}) 100%
  );

  .middle-button__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .middle-button__button {
    width: 18.438rem;
    height: 3.5rem;
    border-radius: 1.75rem;
    font-size: 1.125rem;
  }
`

type MiddleButtonBackgroundVariants = keyof typeof MIDDLE_BUTTON_BACKGROUND_VARIANTS

export interface MiddleButtonBlockProps {
  accessibleLabel: string
  background: MiddleButtonBackgroundVariants
  hasButton: boolean
  button?: {
    label: string
    type?: ButtonModifier
    action: {
      type: ButtonMedusaAction
      value: string
    }
  }
  buttonType?: ButtonMedusaAction
  buttonLabel?: string
  buttonValue?: string
  buttonAriaLabel?: string
}

const MiddleButtonBlock = ({
  accessibleLabel,
  hasButton = true,
  button,
  buttonLabel,
  buttonType,
  buttonValue,
  background = MIDDLE_BUTTON_BACKGROUND_VARIANTS.snowGray,
}: MiddleButtonBlockProps) => {
  const buttonProps = {
    buttonLabel: buttonLabel || button?.label,
    buttonType: buttonType || button?.action?.type,
    buttonValue: buttonValue || button?.action?.value,
    buttonAriaLabel: accessibleLabel || button?.label,
  }

  return (
    <Background background={background}>
      <Container contentClassName="middle-button__container">
        {hasButton && buttonProps && (
          <ButtonLink
            className="middle-button__button"
            action={buttonProps.buttonType}
            value={decodeURL(buttonProps.buttonValue)}
            modifier="solid"
            href={button?.action.value}
            aria-label={accessibleLabel}
          >
            {buttonProps.buttonLabel}
          </ButtonLink>
        )}
      </Container>
    </Background>
  )
}

export default MiddleButtonBlock
